import type { DocumentListQuery } from '@/api/labeling';

export type FileTypeFilter = '' | 'pdf' | 'html' | 'image';
export type StatusFilter = '' | 'pending' | 'labeled' | 'skipped' | 'unreadable';
export type SourceFilter = '' | 'labeling-tool' | 'customer-invoice';

export interface DocFilters {
  file_type: FileTypeFilter;
  status: StatusFilter;
  source: SourceFilter;
}

export const EMPTY_FILTERS: DocFilters = { file_type: '', status: '', source: '' };

export const FILE_TYPE_OPTIONS: { value: FileTypeFilter; label: string }[] = [
  { value: '', label: 'All file types' },
  { value: 'pdf', label: 'PDF' },
  { value: 'html', label: 'HTML' },
  { value: 'image', label: 'Image' },
];

export const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: '', label: 'All statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'labeled', label: 'Labeled' },
  { value: 'skipped', label: 'Skipped' },
  { value: 'unreadable', label: 'Unreadable' },
];

export const SOURCE_OPTIONS: { value: SourceFilter; label: string }[] = [
  { value: '', label: 'All sources' },
  { value: 'labeling-tool', label: 'Labeling tool' },
  { value: 'customer-invoice', label: 'Customer invoice' },
];

export type SortField = 'uploaded' | 'labeled';
export type SortOrder = 'asc' | 'desc';

export interface DocSort {
  field: SortField;
  order: SortOrder;
}

export const DEFAULT_SORT: DocSort = { field: 'uploaded', order: 'desc' };

/** Clicking a column header: toggle order if it's the active field, else
 *  switch to that field starting at descending (newest first). */
export function nextSort(current: DocSort, field: SortField): DocSort {
  if (current.field === field) {
    return { field, order: current.order === 'desc' ? 'asc' : 'desc' };
  }
  return { field, order: 'desc' };
}

// An empty-string filter means "all" and is dropped from the query.
export function toDocumentQuery(
  filters: DocFilters,
  sort: DocSort,
  limit: number,
  offset: number,
): DocumentListQuery {
  return {
    ...(filters.file_type ? { file_type: filters.file_type } : {}),
    ...(filters.status ? { status: filters.status } : {}),
    ...(filters.source ? { source: filters.source } : {}),
    sort: sort.field,
    order: sort.order,
    limit,
    offset,
  };
}
